/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For JSON to CSV, provide an array of objects. The column headers are the union of all keys across the objects; missing values become empty cells.`)
};

const es_cj_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para JSON a CSV, proporciona una matriz de objetos. Los encabezados de las columnas son la unión de todas las claves entre los objetos; los valores faltantes se convierten en celdas vacías.`)
};

const de_cj_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für JSON zu CSV wird ein Array von Objekten benötigt. Die Spaltenüberschriften sind die Vereinigung aller Schlüssel aus diesen Objekten; fehlende Werte werden zu leeren Zellen.`)
};

const nl_cj_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor JSON naar CSV geeft u een reeks objecten. De kolomkoppen zijn de unie van alle sleutels in de objecten; ontbrekende waarden worden lege cellen.`)
};

const fr_cj_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour JSON en CSV, fournissez un tableau d'objets. Les en-têtes de colonnes sont l'union de toutes les clés dans les objets ; les valeurs manquantes deviennent des cellules vides.`)
};

const it_cj_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per JSON a CSV, fornisci un array di oggetti. Le intestazioni delle colonne sono l'unione di tutte le chiavi negli oggetti; i valori mancanti diventano celle vuote.`)
};

const pt_br2_cj_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para JSON para CSV, forneça uma matriz de objetos. Os cabeçalhos de coluna são a união de todas as chaves em todos os objetos; valores ausentes tornam-se células vazias.`)
};

const pt_cj_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para JSON para CSV, forneça um array de objetos. Os cabeçalhos de coluna são a união de todas as chaves nos objetos; valores ausentes tornam-se células vazias.`)
};

const ja_cj_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON から CSV への場合、キーと値のペアを持つレコードのセットを提供してください。カラムヘッダーはすべてのレコード全体に現れるすべてのキーの和集合です。欠落している値は空のセルになります。`)
};

const zh_cj_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对于 JSON 转 CSV，需要提供一个对象数组。列标题是所有对象中出现的所有键的并集；缺失的值会变成空单元格。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_faq2_a", locale)
	if (locale === "en") return en_cj_faq2_a(inputs)
	if (locale === "es") return es_cj_faq2_a(inputs)
	if (locale === "de") return de_cj_faq2_a(inputs)
	if (locale === "nl") return nl_cj_faq2_a(inputs)
	if (locale === "fr") return fr_cj_faq2_a(inputs)
	if (locale === "it") return it_cj_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_cj_faq2_a(inputs)
	if (locale === "pt") return pt_cj_faq2_a(inputs)
	if (locale === "ja") return ja_cj_faq2_a(inputs)
	return zh_cj_faq2_a(inputs)
};